import { INTERNATIONAL_ADD_GIFTS_EMBED } from '@apps/registry/common/components/Catalog/state/CatalogEmbed/catalogEmbed.config';

export const SHOP_REGION_DIALOG_DISMISSED_KEY = 'joy:shopRegionDialogDismissed';

export const SHOP_REGION_DIALOG_RESUME_PARAM = 'intlGiftList';

export const CASH_FUNDS_PATH = INTERNATIONAL_ADD_GIFTS_EMBED.defaultCategoryPublicPath;

export const buildIntlAddGiftsPath = (eventHandle: string) => `/${eventHandle}/edit/registry/${INTERNATIONAL_ADD_GIFTS_EMBED.basePath}`;
